import classNames from 'classnames';
import styles from './Modal.module.scss';

interface Props {
  children: React.ReactNode;
  onClose: () => void;
  closable?: boolean;
  modalClassName?: string;
  contentClassName?: string;
  containerClassName?: string;
}

const Modal = ({ children, onClose, closable = true, modalClassName, contentClassName, containerClassName }: Props) => {
  return (
    <div className={classNames(styles.modal, modalClassName)}>
      <div className={classNames(styles.content, contentClassName)}>
        {closable && (
          <div className={styles.close} onClick={onClose}>
            X
          </div>
        )}
        <div className={classNames(styles.container, containerClassName)}>{children}</div>
      </div>
    </div>
  );
};

export default Modal;
